import React from 'react';
import App from './App';

export const Router: React.FC = () => {
  // Pour l'instant, toutes les routes mènent à l'App principal
  // TODO: Réimplémenter le mail template quand les produits fonctionnent
  
  // Default route
  return <App />;
};
